import React, { useContext } from "react";
import { View, TouchableOpacity, Image } from "react-native";
import GText from "../Elements/GText";
import { StringsContext } from "../DataFactory/useStrings";

const Placeholder = ({ type, action }) => {
  const [strings] = useContext(StringsContext);

  const PlaceholderData = {
    address: {
      icon: require("../assets/images/placeholders/e-address.png"),
      title: strings.s_placeholder_address_title,
      subtitle: strings.s_placeholder_address_subtitle,
    },
    faqs: {
      icon: require("../assets/images/placeholders/e-faq.png"),
      title: strings.s_placeholder_faqs_title,
      subtitle: strings.s_placeholder_faqs_subtitle,
    },
    order: {
      icon: require("../assets/images/placeholders/e-order.png"),
      title: strings.s_placeholder_order_title,
      subtitle: strings.s_placeholder_order_subtitle,
    },
    reviews: {
      icon: require("../assets/images/placeholders/e-review.png"),
      title: strings.s_placeholder_reviews_title,
      subtitle: strings.s_placeholder_reviews_subtitle,
    },
    other: {
      icon: require("../assets/images/placeholders/e-other.png"),
      title: strings.s_placeholder_other_title,
      subtitle: strings.s_placeholder_other_subtitle,
    },
    substitute: {
      icon: null,
      title: "",
      subtitle: "No Products Available.",
    },
    internet: {
      icon: require("../assets/images/placeholders/e-internet.png"),
      title: strings.s_placeholder_internet_title,
      subtitle: strings.s_placeholder_internet_subtitle,
      button: {
        title: strings.w_retry,
      },
    },
  };
  const data = PlaceholderData[type] || PlaceholderData["other"];

  return (
    <View
      style={{
        padding: 30,
        backgroundColor: "white",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 10,
        paddingBottom: 100,
        flex: 1,
      }}
    >
      {data.icon && (
        <Image
          source={data.icon?.default}
          style={{
            height: 130,
            width: 225,
            marginBottom: 30,
          }}
        />
      )}
      {data.title != "" && (
        <GText
          g4
          bold
          dark
          text={data.title}
          style={{ marginBottom: 5, textAlign: "center" }}
        />
      )}
      <GText
        g5
        text={data.subtitle}
        style={{ textAlign: "center", color: "#666" }}
      />
      {data.button && (
        <TouchableOpacity
          onPress={() => (action ? action() : null)}
          style={{
            padding: 40,
            paddingVertical: 7,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 30,
            borderWidth: 1,
            borderColor: "#ccc",
          }}
        >
          <GText g3 text={data.button.title} />
        </TouchableOpacity>
      )}
    </View>
  );
};

export default Placeholder;
